import React from 'react';

//TODO replace with unpkg
export const Silence = () => {
  return (
    <audio
      src="https://res.cloudinary.com/dlzh3j8em/video/upload/v1619210717/silence_xko7fm.mp3"
      autoPlay
      className="hidden"
    />
  );
};
